<template>
    <form class="edit-check">
        <div class="row responsive-label">
            <div class="col-sm-12 col-md-3">
                <label for="number">Email Address</label>
            </div>
            <div class="col-sm-12 col-md">
                <input type="email" id="url" v-model="properties.EmailAddress">
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'notificators-sms-form',
    props: ['properties'],
    created() {
    },
    data() {
        return {
            data: {}
        }
    },
}
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/notificators/EmailForm.vue